import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=6cbf8e8e&"
import script from "./FaqSearch.vue?vue&type=script&lang=js&"
export * from "./FaqSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports